export default __webpack_public_path__ + "static/media/dav-school-logo.bef316e6.png";